export const TEST_ID = {
    EYEBROW: 'hero-lockup__eyebrow',
    TITLE: 'hero-lockup__title',
    SUB_TITLE: 'hero-lockup__sub-title',
    DESCRIPTION: 'hero-lockup__description',
    LINK: 'hero-lockup__link',
    COVER_ARTWORK: 'editorial-card__artwork-cover-artwork',
} as const;

export const EVENTS = {
    linkClick: 'link-click',
} as const;
